import { render, staticRenderFns } from "./FormulationActivityLogTab.vue?vue&type=template&id=6feeb9c4&scoped=true&"
import script from "./FormulationActivityLogTab.vue?vue&type=script&lang=js&"
export * from "./FormulationActivityLogTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationActivityLogTab.vue?vue&type=style&index=0&id=6feeb9c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feeb9c4",
  null
  
)

export default component.exports